import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verifyPortalToken } from '@/lib/api/endpoints/portal';
import { useContactSession } from './ContactSessionProvider';
import './portal.css';

function decodeWorkspaceId(token: string): string | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    // JWT payloads are base64url ('-'/'_'); atob() only accepts standard
    // base64, so convert first (else it throws on most tokens) and re-pad.
    const b64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '=='.slice(0, (4 - (b64.length % 4)) % 4);
    const decoded = JSON.parse(atob(padded));
    return decoded.workspaceId ?? null;
  } catch {
    return null;
  }
}

export function PortalVerify() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setToken } = useContactSession();
  const [error, setError] = useState(false);

  useEffect(() => {
    const magicToken = searchParams.get('token');
    if (!magicToken) {
      setError(true);
      return;
    }
    verifyPortalToken(magicToken)
      .then((sessionToken) => {
        setToken(sessionToken);
        const workspaceId = decodeWorkspaceId(sessionToken);
        if (workspaceId) {
          navigate(`/portal/${workspaceId}/home`, { replace: true });
        } else {
          setError(true);
        }
      })
      .catch(() => setError(true));
  }, []);

  if (error) {
    return (
      <div className="portal-root">
        <div className="portal-card">
          <h1>Link expired</h1>
          <div className="portal-error">This link is invalid or expired.</div>
          <p>Please request a new sign-in link.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="portal-root">
      <div className="portal-card">
        <p>Signing you in…</p>
      </div>
    </div>
  );
}
